import {useParams} from "react-router-dom";
import NotFoundPage from "../NotFoundPage";
import {
  NewApplicationMobilePsychologist,
  NewApplicationStep1Feature
} from "../../features/newApplicationStep1";

const GENERAL_CATEGORIES = [
  'homeMedicalCare',
  'homeNursingCare',
  'homeDentalCare',
  'homeServices',
  'mobileRehabilitation',
  'mobileDietitian',
  'mobilePharmacist',
];

const NewApplicationStep1Page = () => {
  const {category} = useParams();

  if (GENERAL_CATEGORIES.includes(category))
    return <NewApplicationStep1Feature />

  if (category === 'mobilePsychologist')
    return <NewApplicationMobilePsychologist />
  return <NotFoundPage />
}

export default NewApplicationStep1Page;